import type { FieldId } from "../domain/types.js";
import type { CampaignAuthoredFieldSource } from "./types.js";

const YAML_FILES = import.meta.glob("./common/fields/*.yml", {
  query: "?raw",
  import: "default",
  eager: true,
}) as Record<string, string>;

const authoredByFieldId = new Map<FieldId, string>();

for (const [filePath, yamlText] of Object.entries(YAML_FILES)) {
  const fileName = filePath.split("/").pop()!;
  const fieldId = fileName.replace(/\.yml$/i, "") as FieldId;
  authoredByFieldId.set(fieldId, yamlText);
}

export const commonAuthoredFields: CampaignAuthoredFieldSource = {
  get(fieldId: FieldId) {
    const yamlText = authoredByFieldId.get(fieldId);
    if (!yamlText) return null;
    return {
      fieldId,
      fileName: `${fieldId}.yml`,
      yamlText,
    };
  },
};

